<script setup>
import Icon from './Icon.vue'
defineProps({ moduleMeta: { type: Object, required: true } })
</script>

<template>
  <div class="placeholder-module">
    <div class="icon-wrap"><Icon :name="moduleMeta.icon" :size="26" /></div>
    <h3>{{ moduleMeta.label }}</h3>
    <p class="muted">All modules are fully built in this prototype.</p>
  </div>
</template>
